__turbopack_context__.v({
  "carousel": "index-module-scss-module__YbX-vG__carousel",
  "imageWrapper": "index-module-scss-module__YbX-vG__imageWrapper",
  "mainContent": "index-module-scss-module__YbX-vG__mainContent",
  "pane": "index-module-scss-module__YbX-vG__pane",
  "paneBlock": "index-module-scss-module__YbX-vG__paneBlock",
  "paneCollection": "index-module-scss-module__YbX-vG__paneCollection",
  "paneImage": "index-module-scss-module__YbX-vG__paneImage",
  "paneText": "index-module-scss-module__YbX-vG__paneText",
  "topLine": "index-module-scss-module__YbX-vG__topLine",
});
